import React from 'react';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		if (process.env.NODE_ENV === 'development') {
			console.error('ErrorBoundary caught:', error, errorInfo);
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: '40px', textAlign: 'center' }}>
					<h2>Une erreur est survenue</h2>
					<p>Veuillez rafraîchir la page ou réessayer plus tard.</p>
					<button
						onClick={() => window.location.reload()}
						style={{
							padding: '10px 20px',
							background: 'rgb(23, 124, 124)',
							color: '#fff',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer',
							fontSize: '14px'
						}}
					>
						Rafraîchir la page
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
